export enum EDistrictLocales {
  single = 'районе',
  plural = 'районах',
}

/**
 * Формирует слово "районы" в нужном склонении.
 * @param count
 */
export function getDistrictLocales(count: number): string {
  const lastNumber = Number(count.toString().slice(-1));

  switch (true) {
    case lastNumber === 1 && count !== 11:
      return EDistrictLocales.single;
    default:
      return EDistrictLocales.plural;
  }
}
